<template>
  <div class="score-row" :style="{backgroundColor: bodyBackgroundColor}">
    <BaseText3 class="rank" :text="rank" :style="{color: rankTextColor, backgroundColor: rankBackgroundColor}"/>
    <div class="name-container">
      <BaseText3 class="firstname" :text="name"/>
      <BaseText3 class="lastname" :text="`${surname[0]}.`" v-if="surname"/>
    </div>
    <BaseText3 class="score" :text="score"/>
  </div>
</template>

<script>
import BaseText3 from '@/components/BaseText3/BaseText3'
export default {
  components: {
    BaseText3
  },
  props: {
    rank: {
      type: [String, Number],
      required: true
    },
    name: {
      type: String,
      required: true
    },
    surname: {
      type: String,
      required: true
    },
    score: {
      type: [String, Number],
      required: true
    },
    bodyBackgroundColor: {
      type: String,
      default: 'var(--color-gray-2)'
    },
    rankBackgroundColor: {
      type: String,
      default: 'var(--color-white-1)'
    },
    rankTextColor: {
      type: String,
      default: 'var(--color-black-1)'
    }
  }
}
</script>

<style lang="scss" scoped>
.score-row {
  width: 100%;
  display: flex;
  justify-content: space-between;
  flex-shrink: 0;
}
.score-row > * {
  color: var(--color-white-1);
  padding: 0 var(--spacing-2);
  display: flex;
  align-items: center;
}
.score-row * {
  font-size: 1.5rem;
}
.rank {
  flex-shrink: 0;
  width: 4rem;
  justify-content: center;
}
.name-container {
  width: 100%;
  display: flex;
  overflow: hidden;
  white-space: nowrap;
}
.firstname {
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-right: 0.5rem;
}
</style>
